import { useState, useEffect } from 'react'

let _highlighter = null
let _promise = null

const LANGS = ['javascript', 'typescript', 'ruby', 'bash', 'json', 'yaml', 'markdown', 'sql', 'html', 'css']

export function useShiki() {
  const [highlighter, setHighlighter] = useState(_highlighter)
  const [loading, setLoading] = useState(!_highlighter)

  useEffect(() => {
    if (_highlighter) {
      setHighlighter(_highlighter)
      setLoading(false)
      return
    }

    if (!_promise) {
      _promise = import('shiki').then(({ createHighlighter }) =>
        createHighlighter({ themes: ['github-dark'], langs: LANGS })
      ).then(h => {
        _highlighter = h
        return h
      })
    }

    _promise.then(h => {
      setHighlighter(h)
      setLoading(false)
    })
  }, [])

  return { highlighter, loading }
}
